import { EventIds, ConferenceIds, WebinarTypeVoc } from '../constants/webinar-data'

const defineWebinarType = (webinarId: number | undefined) => {
  if (webinarId && EventIds.includes(webinarId)) return WebinarTypeVoc.event
  if (webinarId && ConferenceIds.includes(webinarId)) return WebinarTypeVoc.conference
  return WebinarTypeVoc.event
}

const defineWebinarSubtype = (expertCouncil?: boolean) => {
  if (expertCouncil) return 'ЭКСПЕРТНЫЙ СОВЕТ'
  return 'ВЕБИНАР'
}

export { defineWebinarType, defineWebinarSubtype }
